import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { RequestState } from "../../types/requestState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function setRequest(
  state: State,
  timeRecord: State[number]["timeRecord"],
  request: RequestState,
): State {
  const index = state.findIndex(
    (req) => req.timeRecord.uuid === timeRecord.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { timeRecord, request },
        ...state.slice(index + 1),
      ]
    : [...state, { timeRecord, request }];
}

function handleRequest(
  state: State,
  { timeRecord }: Boundaries["deleteTimeRecord"]["request"],
): State {
  return setRequest(state, timeRecord, setRequestStateToPending());
}

function handleSuccess(
  state: State,
  { timeRecord }: Boundaries["deleteTimeRecord"]["success"],
): State {
  return setRequest(state, timeRecord, setRequestStateToSuccess());
}

function handleFailure(
  state: State,
  { timeRecord }: Boundaries["deleteTimeRecord"]["failure"],
): State {
  return setRequest(state, timeRecord, setRequestStateToFailure());
}

const reduceState = createStateReducer(initialState, {
  [events.deleteTimeRecordRequested]: handleRequest,
  [events.deleteTimeRecordSucceeded]: handleSuccess,
  [events.deleteTimeRecordFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
